import type { PaymentMethodSummary } from './types';

export type PaymentOnPurchase = PaymentMethodSummary['paymentsOnPurchase'][number];

export const isCardPayment = ({ paymentMethod }: PaymentOnPurchase) =>
  paymentMethod === 'Card' || paymentMethod === 'GenericCard';

export const isBankPayment = ({ paymentMethod }: PaymentOnPurchase) =>
  paymentMethod === 'Ach' || paymentMethod === 'Rtp';

export const getMostRecentPayment = (
  paymentsOnPurchase: readonly PaymentOnPurchase[] | undefined,
  predicate: (payment: PaymentOnPurchase) => boolean = () => true
): PaymentOnPurchase | undefined =>
  [...(paymentsOnPurchase ?? [])]
    .filter(predicate)
    .sort((a, b) => b.createdOnUtc.getTime() - a.createdOnUtc.getTime())[0];
